import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8f3aeac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alt-table w-full" }
const _hoisted_2 = { class: "mr-auto !pt-4 text-center" }

import skeletonRow from './skeletonRow.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'skeletonTable',
  props: ["width", "rows"],
  setup(__props) {


const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.rows, (item, index) => {
      return (_openBlock(), _createElementBlock("tr", { key: index }, [
        _createElementVNode("td", _hoisted_2, [
          _createVNode(skeletonRow, {
            width: props.width
          }, null, 8, ["width"])
        ])
      ]))
    }), 128))
  ]))
}
}

})